/**
 * Reproduce un sonido de notificación usando Web Audio API
 * Genera un sonido tipo "ding" sin necesidad de archivos externos
 */
export function playNotificationSound() {
  try {
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    
    // Crear oscilador para el tono
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    // Conectar nodos
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    // Configurar el sonido (tipo "ding" agradable)
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(800, audioContext.currentTime); // Frecuencia inicial alta
    oscillator.frequency.exponentialRampToValueAtTime(400, audioContext.currentTime + 0.1); // Baja rápidamente
    
    // Envelope para volumen (fade in/out suave)
    gainNode.gain.setValueAtTime(0, audioContext.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.3, audioContext.currentTime + 0.01); // Fade in rápido
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3); // Fade out suave
    
    // Reproducir
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.3);
    
    // Limpiar después
    setTimeout(() => {
      audioContext.close();
    }, 400);
    
  } catch (error) {
    console.warn('No se pudo reproducir el sonido de notificación:', error);
  }
}
